/**
 * Normalize legacy conversation fields to a consistent shape.
 */
import type { Conversation } from '../types';

export const normalizeConversation = (
  conversation: Conversation,
): Conversation => {
  const normalized: Conversation = {
    ...conversation,
    isMuted: conversation.isMuted ?? conversation.isMute ?? false,
    isFavourite: conversation.isFavourite ?? conversation.category === 'favourite',
    isBlocked: conversation.isBlocked ?? false,
    isPinned: conversation.isPinned ?? false,
    lastMessageAt: conversation.lastMessageAt ?? 0,
    memberCount: conversation.memberCount ?? conversation.members?.length ?? 0,
  };

  const firstMemberAvatar = normalized.members?.[0]?.avatar;
  const usesLegacyMemberAvatar =
    normalized.category === 'groups' &&
    !!normalized.avatar &&
    !!firstMemberAvatar &&
    normalized.avatar === firstMemberAvatar &&
    (normalized.members?.length ?? 0) > 1;

  if (usesLegacyMemberAvatar) {
    return { ...normalized, avatar: null };
  }

  return normalized;
};

export const sortConversations = (
  conversations: Conversation[],
): Conversation[] => {
  const visible = conversations.filter(c => !c.isBlocked);

  return [...visible].sort((a, b) => {
    if (a.isPinned !== b.isPinned) {
      return a.isPinned ? -1 : 1;
    }

    if (a.isPinned && b.isPinned) {
      return (a.pinnedAt || 0) - (b.pinnedAt || 0);
    }

    if (a.isFavourite !== b.isFavourite) {
      return a.isFavourite ? -1 : 1;
    }

    return (b.lastMessageAt || 0) - (a.lastMessageAt || 0);
  });
};
